import {
  TOOLBAR_TOOLS as ALL_TOOLBAR_TOOLS,
  DROPDOWN_ITEMS_MAP as ALL_DROPDOWN_ITEMS_MAP,
  type ToolDefinition,
  type DropdownItem,
} from '@genieartinc/studio-ui/components/canvas/toolbar/toolbar-config'
import { FEATURES } from '@/lib/features'

export {
  TEXT_DROPDOWN_ITEMS,
  UTILITY_DROPDOWN_ITEMS,
  IMAGE_DROPDOWN_ITEMS,
  VIDEO_DROPDOWN_ITEMS,
} from '@genieartinc/studio-ui/components/canvas/toolbar/toolbar-config'
export type { ToolDefinition, DropdownItem }

/**
 * Toolbar categories whose node cannot be generated yet. The tool rail, the
 * tool catalogue and the command palette are all built from the two exports
 * below, so dropping a category here removes every one of its entry points.
 * THREE_D_DROPDOWN_ITEMS is deliberately not re-exported from here.
 */
const HIDDEN_TOOL_IDS: readonly string[] = FEATURES.NODE_3D ? [] : ['3d']

/** Create shader authors on the node. Shader templates is the only library entry. */
export const SHADER_DROPDOWN_ITEMS: DropdownItem[] = [
  { id: 'shader', label: 'Create shader', icon: 'sparkles', shortcut: '1', detail: 'Free' },
  { id: 'shader-library', label: 'Shader templates', icon: 'library', shortcut: '2', detail: 'Free', opensPanel: true },
]

export const TOOLBAR_TOOLS: ToolDefinition[] = ALL_TOOLBAR_TOOLS.filter(
  (tool) => !HIDDEN_TOOL_IDS.includes(tool.id)
)

export const DROPDOWN_ITEMS_MAP: Record<string, DropdownItem[]> = Object.fromEntries(
  Object.entries(ALL_DROPDOWN_ITEMS_MAP)
    .filter(([id]) => !HIDDEN_TOOL_IDS.includes(id))
    .map(([id, items]) => [id, id === 'vibe-code' ? SHADER_DROPDOWN_ITEMS : items]),
)
